/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


jQuery(document).ready(function ($) {

    $('#table-storia-oggetto').DataTable({
        responsive: true,
        "columns": [
            {"data": "Posizione"},
            {"data": "Nome Annuncio"},
            {"data": "Condizioni"},
            {"data": "Punto ToornaQui"},
            {"data": "Zona Ritiro"},
            {"data": "Indirizzo proprietario annuncio"},
            {"data": "Autore annuncio"},
            {"data": "Ex Proprietario"},
            {"data": "Beneficiario"},
            {"data": "Stato Transazione"},
            {"data": "Data Annuncio"},
            {"data": "Foto"}

        ],
        "oLanguage": {
            "sLengthMenu": "Mostra _MENU_ risultati per pagina",
            "sZeroRecords": "Nessuno scambio trovato",
            "sInfo": "Visualizzati Scambi da _START_ a _END_ di _TOTAL_ risultati",
            "sInfoEmpty": "Mostra 0 su 0 di 0 risultati",
            "sInfoFiltered": "(Filtrati da _MAX_ risultati totali)",
            "sSearch": "Filtra:",
            "oPaginate": {
                "sFirst": "|<",
                "sLast": ">|",
                "sNext": ">",
                "sPrevious": "<"
            }
        },
        "aoColumnDefs": [{"bSortable": false, "aTargets": [9]}]
    });
});